import React from 'react';
import './PlatformFeaturesSection.css';

const PlatformFeaturesSection = () => {
  const features = [
    {
      title: 'Website Builder',
      description: 'Custom web development services creating dynamic websites and web applications tailored to your business needs. We build responsive, scalable solutions using modern technologies.',
      icon: 'fas fa-laptop-code'
    },
    {
      title: 'Payments & Checkout',
      description: 'E-commerce platforms with secure payment integration and cloud-integrated systems for seamless transaction processing. We integrate multiple payment methods to ensure smooth checkout experiences for your customers.',
      icon: 'fas fa-credit-card'
    },
    {
      title: 'Analytics Dashboard',
      description: 'Real-time business intelligence and performance metrics as part of our digital transformation solutions. Track traffic, sales, customer behavior, and key performance indicators.',
      icon: 'fas fa-chart-bar'
    },
    {
      title: 'Customer Management',
      description: 'Custom CRM solutions integrated into your digital infrastructure. Centralized contact management, communication history, and customer segmentation tools for your business.',
      icon: 'fas fa-users'
    },
    {
      title: 'Automation Engine',
      description: 'Workflow automation and business process optimization as part of digital transformation. Automated emails, SMS, notifications, and process triggers to streamline operations.',
      icon: 'fas fa-bolt'
    },
    {
      title: 'Booking & Orders',
      description: 'Order management systems for e-commerce platforms. Appointment scheduling, reservations, order processing, and delivery tracking integrated into your custom web application.',
      icon: 'fas fa-calendar-check'
    }
  ];

  return (
    <section className="platform-features-section">
      <div className="container">
        <h2 className="section-title">What You Get</h2>
        <p className="section-subtitle">All the tools you need to run your business online</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeaturesSection;